class SuitOptions extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('select').forEach((select) => {
            select.addEventListener('change', () => {
                this.updateOptions();
            });
        });
        this.timeoutIds = '';
        
    }

    init() {
        this.colorSwatches.forEach(swatch => {
            const swatchOptionsWrapper = swatch.querySelectorAll('.color-swatch__wrapper')
            // console.log('swatchOptionsWrapper', swatchOptionsWrapper);
            swatchOptionsWrapper.forEach(swatchOption => {
                swatchOption.addEventListener('click', this.colorSwatchClick.bind(this));
            });
        });

        this.sizeDropdowns.forEach(sizeDropdown => {
            sizeDropdown.addEventListener('change', this.sizeDropdownChange.bind(this));
        });

        this.checkboxDom.addEventListener('change', this.checkboxChange.bind(this));
    }

    showTips() {
        this.closest('.product-suit-options__wrapper').classList.add('show-tips');
        if (this.timeoutIds) {
            clearTimeout(this.timeoutIds);
        }
        this.timeoutIds = setTimeout(() => {
            this.closest('.product-suit-options__wrapper').classList.remove('show-tips');
        }, 3000);
    }

    sizeDropdownChange(event) {
        const select = event.currentTarget;

        if(!select) return;
        this.updateOptions();

        if (this.dataset.selectedVariantId) {
            const checkboxDom = this.closest('.product-suit-options__wrapper').querySelector('.custom-checkbox__wrapper input[type="checkbox"]');
            if (checkboxDom) {
                checkboxDom.checked = true;
            }
        }
    }

    colorSwatchClick(event) {
        const swatch = event.currentTarget;
        if (swatch.classList.contains('selected')) return;
        swatch.closest('.product-suit__option').querySelectorAll('.color-swatch__wrapper').forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        const select = swatch.closest('.product-suit__option').querySelector('select');
        if (select) {
            select.value = swatch.dataset.value;
            this.updateOptions();

            if (this.dataset.selectedVariantId) {
                const checkboxDom = this.closest('.product-suit-options__wrapper').querySelector('.custom-checkbox__wrapper input[type="checkbox"]');
                if (checkboxDom) {
                    checkboxDom.checked = true;
                }
            }
        }
    }

    checkboxChange(event) {
        if (event.target.checked === true) {
            if (!this.dataset.selectedVariantId) {
                event.target.checked = false;
                this.showTips.bind(this)();
            }
        }
        
    }

    updateOptions() {
        const selectedOptions = Array.from(this.querySelectorAll('select')).map(select => select.value);
        // console.log('Selected options:', selectedOptions);
        const variant = this.getVariantFromOptions(selectedOptions);
        if (variant) {
            // console.log('Found variant:', variant.id);
            this.setAttribute('data-selected-variant-id', variant.id);
            this.dispatchEvent(new CustomEvent('variantChange', { detail: { variant } }));
        } else {
            // console.log('No variant found for options:', selectedOptions);
        }
    }

    getVariantFromOptions(selectedOptions) {
        const productJsonElement = this.closest('.accordion').querySelector('.product-json');
        if (!productJsonElement) {
            console.error('Product JSON not found');
            return null;
        }
        const productData = JSON.parse(productJsonElement.textContent);
        return productData.variants.find(variant => 
            variant.options.every((option, index) => option === selectedOptions[index])
        );
    }

    connectedCallback() {
        this.colorSwatches = this.querySelectorAll('.product-suit__option.product-suit__option--color');
        this.sizeDropdowns = this.querySelectorAll('.product-suit__option.product-suit__option--size select');
        this.checkboxDom = this.closest('.product-suit-options__wrapper').querySelector('.custom-checkbox__wrapper input[type="checkbox"]');
        this.init();
        // 初始化时设置正确的变体ID
        this.updateOptions();
    }

    disconnectedCallback() {
        this.colorSwatches.forEach(swatch => {
            swatch.removeEventListener('click', this.colorSwatchClick.bind(this));
        });
    }
}

customElements.define('suit-options', SuitOptions); 

document.addEventListener('DOMContentLoaded', () => {
    const suitProductsDom = document.querySelectorAll('.suit-items__wrapper .accordion');

    if (suitProductsDom.length === 0) return;

    function updatePlayersRelatedUI(playersCount) {
        suitProductsDom.forEach(suitProduct => {
            const productItems = suitProduct.querySelectorAll('.product-suit-options__wrapper');

            productItems.forEach((productItem, index) => {
                if (index < playersCount) {
                    productItem.classList.remove('product-suit-options__wrapper--hide');
                } else {
                    productItem.classList.add('product-suit-options__wrapper--hide');
                }
            });
        })
        
        console.log(`Updated players count to: ${playersCount}`);
    }

    function onPlayersOfNumberChange(input, playersElement) {
        console.log('Input changed in players_of_number:', input.value);
        
        updatePlayersRelatedUI(input.value, playersElement);
        
        // 触发自定义事件
        this.dispatchEvent(new CustomEvent('playersOfNumberChange', { 
            detail: { input, value: input.value, playersElement } 
        }));
    }

    function handlePlayersOfNumberChange(event) {
        const playersElement = event.target.closest('.players_of_number');
        if (!playersElement) return;

        // 处理输入变化事件
        console.log('Players of number input changed:', event.target.value);
        onPlayersOfNumberChange(event.target, playersElement);
    }

    // save bound event handler references for later removal
    const boundPlayersChangeHandler = handlePlayersOfNumberChange.bind(this);

    document.addEventListener('change', boundPlayersChangeHandler);
})
